export const filterPrice = (headers, priceColumn = ["unitPrice"]) => {
    const col = priceColumn;
    return headers.filter((header) => !col.includes(header.value));
};
